// attendanceSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { GeoTrackingDetailsResponse, GeoTrackingResponse } from "../../../types/model/geoTrackingTypes";
import { getGeoTrackingDetails, getGeoTrackingList } from "./api";


interface GeoTrackingState {
  geoTrackingList: GeoTrackingResponse | null;
  geoTrackingDetails: GeoTrackingDetailsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: GeoTrackingState = {
  geoTrackingList: null,
  geoTrackingDetails: null,
  loading: false,
  error: null,
};

export const GeoTrackingSlice = createSlice({
  name: "geoTracking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGeoTrackingList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.geoTrackingList = null;
      })
      .addCase(getGeoTrackingList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.geoTrackingList = payload;
        state.error = null;
      })
      .addCase(getGeoTrackingList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Unknown error";
        state.geoTrackingList = null;
      });
      builder
      .addCase(getGeoTrackingDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.geoTrackingDetails = null;
      })
      .addCase(getGeoTrackingDetails.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.geoTrackingDetails = payload;
      })
      .addCase(getGeoTrackingDetails.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Something went wrong";
      });
  },
});

export default GeoTrackingSlice.reducer;
